<template>
  <div id="page_kasproagen">
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-toolbar color="primary" dark flat dense cad>
          <v-toolbar-title class="subheading">Add New Application</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-layout fluid row wrap>
              <v-flex lg12 sm12 xs12>
                <v-text-field label="App Name" name="name" v-model="addApp.appname"></v-text-field>
              </v-flex>
              <v-flex lg12 sm12 xs12>
                <v-text-field label="Version" name="version" v-model="addApp.version"></v-text-field>
              </v-flex>
              <v-flex lg6 sm6 xs6>
                <v-text-field
                  label="Primary Color"
                  name="primarycolor"
                  v-model="addApp.primary_color"
                ></v-text-field>
              </v-flex>
              <v-flex lg6 sm6 xs6>
                <v-text-field
                  label="Primary Color Dark"
                  name="primary_color_dark"
                  v-model="addApp.primary_color_dark"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeDialog()">Cancel</v-btn>
          <v-btn color="success" @click="simpanForm(addApp)">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Type something"
                v-model="search"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
              <v-btn color="success" @click.native="openmodal()">
                <v-icon dark>add</v-icon>Add
              </v-btn>
            </v-toolbar>

            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="kaspro_agen"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                class="elevation-1"
                item-key="id"
                select-all
                :loading="loading"
                v-model="complex.selected"
              >
                <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <td>
                    <v-checkbox primary hide-details v-model="props.selected"></v-checkbox>
                  </td>
                  <td class="text-xs-left">{{ props.item.accountnumber }}</td>
                  <td class="text-xs-left">{{ props.item.msisdn }}</td>
                  <td class="text-xs-left">{{ props.item.fullname }}</td>
                  <td class="text-xs-left">{{ formatDate(props.item.updated_at) }}</td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
export default {
  data: () => ({
    state_add: false,
    search: "",
    valid: false,
    complex: {
      selected: [],
      headers: [
        {
          text: "AccountNumber",
          value: "accountnumber"
        },
        {
          text: "MSISDN",
          value: "msisdn"
        },
        {
          text: "Full Name",
          value: "fullname"
        },
        {
          text: "updated At",
          value: "update_at"
        }
      ],
      items: []
    },
    addApp: {
      appname: "",
      serverkey: "firebase server key",
      version: "1.0",
      primary_color: "#3F51B5",
      primary_color_dark: "#3949AB"
    }
  }),
  created() {
    // this.getApplist();
  },
  mounted() {
    this.getApplist();
  },
  computed: {
    ...mapState("AdminMitraModule", ["kaspro_agen", "dialog", "loading"])
  },
  methods: {
    ...mapActions({
      logout: "account/logout",
      AddNew: "applikasi/AddNewApp",
      closeDialog: "applikasi/closeDialog",
      OpenDialogForm: "applikasi/OpenDialogForm",
      getApplist: "AdminMitraModule/getKasproagen"
    }),
    OpenFormEdit(data) {
      this.addApp = data;
      this.state_add = false;
      this.OpenDialogForm();
    },
    openmodal() {
      this.state_add = true;
      this.OpenDialogForm();
    },
    simpanForm(data) {
      if (this.state_add) {
        this.AddNew(data);
      } else {
        this.AddNew(data);
      }
      this.state_add = false;
      this.getApplist();
    },
    formatDate(value) {
      return moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
    },
    statusformat(value) {
      let a = "Non-Active";
      if (value === 1) {
        a = "Active";
      }
      return a;
    }
  }
};
</script>

<style>
</style>
